import { colorOptions } from "src/shared/modules/profile/theme/themeConstants";
import api from "../../../../../features/auth/axiosConfig";

export interface Theme {
  background_color: string;
  font_color: string;
  font_family: string;
  businessName?: string;
}

export const useThemeSetup = (organization_name: string = "default") => {
  const setupTheme = async (organization_name: string) => {
    try {
      const res = await api.get(`/pos/theme`);
      const themes: Theme[] = res.data.result;

      if (themes.length > 0) {
        const apiTheme = themes[0];
        const bg = String(apiTheme.background_color);

        // ✅ Find matching key in colorOptions (like "DodgerBlue" for "#1E90FF")
        const matchedEntry = Object.entries(colorOptions).find(([key, value]) => value.includes(bg));
        const matchedColorKey = matchedEntry ? matchedEntry[0] : "DodgerBlue";

        // console.log("Matched theme color:", matchedColorKey);

        // ✅ If old theme (like "#6495ED" + "Franklin Gothic Medium"), reset to new default
        let finalTheme: Theme;
        // console.log("matchedEntry", matchedEntry);

        if (apiTheme.background_color === "#6495ED" && apiTheme.font_color === "white" && apiTheme.font_family === "Franklin Gothic Medium") {
          // Old default detected → migrate to new default
          finalTheme = {
            background_color: "DodgerBlue",
            font_color: "white",
            font_family: "Sans-serif",
          };
          await api.put(`/pos/theme`, finalTheme); // only update if old default
          window.location.reload();
        } else {
          finalTheme = {
            background_color: matchedColorKey || apiTheme.background_color,
            font_color: apiTheme.font_color,
            font_family: apiTheme.font_family,
          };
        }

        // ✅ Save in sessionStorage
        Object.entries(finalTheme).forEach(([key, value]) => sessionStorage.setItem(`${key}${organization_name}`, value));

        return finalTheme;
      }
    } catch (error) {
      console.error("Theme setup error:", error);
      const fallbackTheme: Theme = {
        background_color: "DodgerBlue",
        font_color: "white",
        font_family: "Sans-serif",
      };
      Object.entries(fallbackTheme).forEach(([key, value]) => sessionStorage.setItem(`${key}${organization_name}`, value));
      return fallbackTheme;
    }
  };

  return { setupTheme };
};
